import React from 'react';
import { LayoutHelper } from 'helper';
import moduleslogo from '../../../../../css/img/modules-logos.jpg';

export const EskimosLoginPageTemplate = ({t, children}) => {
  return (
    <div className="login-page animated fadeInDown smart-style-6">
      <LayoutHelper.fullPageLayoutHeader/>
      <div id="main" role="main">
        <div id="content" className="container">
          <div className="row">
            <div className=" col-sm-5 col-md-5 col-lg-4 hidden-sm hidden-xs">
              <h1
                className="login-header-big">{t("Welcome")}</h1>
            </div>
          </div>
          <div className="row form-wrap">
            <div className="form-wrap__inner">
              <div className="hidden-xs hidden-sm col-md-7 col-lg-8">
                <img className="modules-logo" src={moduleslogo} />
              </div>
              <div className="col-sm-offset-3 col-md-offset-0 col-sm-6 col-md-5 col-lg-4">
                <div className="well no-padding">
                  
                  { children }
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
